import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Commonservice } from '../../services/commonservice';

export const authGuard: CanActivateFn = (route, state) => {
  const commonSvc = inject(Commonservice)
  const router = inject(Router);
  if (commonSvc.isLoggedIn) {
    return true;
  }
  router.navigate(['/signin']);
  return false;
};
